export default function getAppStats(webappENV,val1){
  try{
    //for(let i=0; i<1000; ++i){
    //  let tmpRes = appStats_getNumber();
    //  if(validate_luhn_number(tmpRes)===false){ console.log("VALID=N tmpRes="+tmpRes); }
    //  else                                    { console.log("VALID=Y tmpRes="+tmpRes); }
    //}

    let dt = appStats_getDate(val1);//"2909200418291895194227";
    let ln = appStats_getNumber();
    let mx = "";
    var kk = "HsbZYI24YrR2Xy4W89sVExSZzXAf";
    if(webappENV==="DEV"){
      kk = "KP3fsdfsd4f3p4".substring(0,2)+"A1o3sdffd4sdff".substring(1,3)+"psPbh4YHHaf45d".substring(2,4)+"esfp&4YHHasd4d".substring(3,5)+"gsaa1#Yasd@45d".substring(4,6)+"f6uasN9HH$dfgg".substring(5,7);//DEV
    }
    else{
      kk = "Ilz0S0uQeeUb06".substring(0,2)+"4l0ojPihhZi35i".substring(1,3)+"V5fs4i0Aqiit6Q".substring(2,4)+"XF4SQAmOaxlGEH".substring(3,5)+"XLEemFAMiiklT4".substring(4,6)+"h5iEnLj0CPLMgn".substring(5,7);//PROD
    }

    for(let i=0; i<dt.length; ++i){
      let dt_c = (i>dt.length) ? "" : dt.charAt(i);
      let ln_c = (i>ln.length) ? "" : ln.charAt(i);
      mx = mx + dt_c + ln_c;
    }
    let kkdc1 = "EORCceZMyIg6Sn".substring(2,4)+"YLIoTmNfpY7NgH".substring(3,5)+"B9By8TYkLrCyi6".substring(0,2)+"an3KhP7lyogLFs".substring(1,3)+"2SXGrs0giPIJcS".substring(5,7)+"LzwvuIUHRnr2m5".substring(3,5);
    let mxdc1 = "";
    for(let i=0; i<dt.length; ++i){
      let dt_c = (i>dt.length) ? "" : dt.charAt(i);
      let ln_c = (i>ln.length) ? "" : ln.charAt(i);
      mxdc1 = mxdc1 + dt_c + ln_c;
    }
    let kkdc2 = "vmI1zXAbzoxvbJ".substring(1,3)+"gOJ0MNFvJOra2o".substring(5,7)+"iIwbEmTkXal0Vv".substring(2,4)+"3h1dgZvbtkBnDj".substring(0,2)+"JZJVCrLNZ10wiO".substring(4,6)+"fvkNN0B2KvA0Lu".substring(4,6);
    let mxdc2 = "";
    for(let i=0; i<dt.length; ++i){
      let dt_c = (i>dt.length) ? "" : dt.charAt(i);
      let ln_c = (i>ln.length) ? "" : ln.charAt(i);
      mxdc2 = mxdc2 + dt_c + ln_c;
    }
    if(kkdc1===""){console.log("dc=po{1,2}");}
    if(kkdc2===""){console.log("dc=pp{2,3}");}
    //console.log("getAppStats dt="+dt);
    //console.log("getAppStats ln="+ln);
    //console.log("getAppStats mx="+mx);
    //console.log("getAppStats kk="+kk);
    return new Buffer(appStats_xor(mx,kk)).toString('base64');
  }catch(err){
    console.log("gas err="+err);
  }
  return "";
}
function appStats_getNumber(){
  for(var i=0; i<10; ++i){
    var wscr = appStats_getNumber_aux();
    if(wscr!==""){
      return wscr;
    }
  }
  return "";
}
function appStats_getNumber_aux(){
  try{
    let length = 8;
    let digits = [0,0,0,0,0,0,0,0];//new Array(length);
    for(let i=0; i<length-1; i++){
    let tmp = (Math.random())*10;
      if(Math.ceil(tmp)>=10){ tmp=(Math.random())*9;}
      if(Math.ceil(tmp)<=0) { tmp=6.0;}
      digits[i] = Math.ceil(tmp);
    }
    let sum = 0;
    let alt = true;
    for(let i = length-2; i >= 0; i--){
      if(alt){
        let temp = digits[i];
        temp *= 2;
        if(temp > 9){
          temp -= 9;
        }
        sum += temp;
      }
      else{
        sum += digits[i];
      }
      alt = !alt;
    }
    let modulo = sum % 10;
    if(modulo > 0){
      digits[length-1] = 10 - modulo;
    }
    let resStr = "";
    for(let i=0; i<length; i++){
     resStr = resStr+digits[i].toString();
    }
    return resStr;
  }catch(err){
    console.log("asgn err="+err);
  }
  return "";
}
// function validate_luhn_number(value) {
//   // Accept only digits, dashes or spaces
//   if (/[^0-9-\s]+/.test(value)) return false;
//
//   // The Luhn Algorithm. It's so pretty.
//   let nCheck = 0, bEven = false;
//   value = value.replace(/\D/g, "");
//
//   for (var n = value.length - 1; n >= 0; n--) {
//     var cDigit = value.charAt(n),
//         nDigit = parseInt(cDigit, 10);
//
//     if (bEven && (nDigit *= 2) > 9) nDigit -= 9;
//
//     nCheck += nDigit;
//     bEven = !bEven;
//   }
//
//   return (nCheck % 10) === 0;
// }
function appStats_xor(text,key){
  try{
    var result = '';
    for (var i = 0; i < text.length; i++) {
        result += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return result;
  }catch(err){
    console.log("asx err="+err);
    return "";
  }
}
function appStats_getDate(val1){
  try{
    var d3 = new Date();
    let year  = d3.getUTCFullYear().toString();
    let month = (d3.getUTCMonth()+1).toString();  month = month.length===1 ? "0"+month : month;
    let day   = d3.getUTCDate().toString();       day   = day.length===1   ? "0"+day   : day;
    let hh    = d3.getUTCHours().toString();      hh    = hh.length===1    ? "0"+hh    : hh;
    let mm    = d3.getUTCMinutes().toString();    mm    = mm.length===1    ? "0"+mm    : mm;
    let ss    = d3.getUTCSeconds().toString();    ss    = ss.length===1    ? "0"+ss    : ss;
    return year+month+day+hh+mm+ss;
  }catch(err){
    console.log("asgd err="+err);
  }
  return "";
}
